var AnalysisOption = /* @__PURE__ */ ((AnalysisOption2) => {
  AnalysisOption2["ProductionAnalysis"] = "ProductionAnalysis";
  AnalysisOption2["PreviewAnalysis"] = "PreviewAnalysis";
  return AnalysisOption2;
})(AnalysisOption || {});
export {
  AnalysisOption
};
//# sourceMappingURL=AnalysisGroup.js.map
